import toast from "react-hot-toast";
import { clientRoutes } from "../routes";
import axiosInstance from "./Axios";

export class AgentApi {
  static SearchAgentList = async (
    search: string,
    limit?: number,
    registration_status?: string,
  ) => {
    try {
      let url = `admin/agents?search=${search}`;

      if (limit) {
        url += `&limit=${limit}`;
      }

      if (registration_status) {
        url += `&registration_status=${registration_status}`;
      }

      const res = await axiosInstance.get(url);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static verifyAgentPhone = async (agent_id: string) => {
    try {
      const res = await axiosInstance.post(
        `admin/agents/verify-phone/${agent_id}`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.response?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static DesignationsList = async () => {
    try {
      const res = await axiosInstance.get(`agent/search-designations`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static CreateAgentProfile = async (data: any) => {
    try {
      const res = await axiosInstance.post(`agent/create-profile`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static cityList = async () => {
    try {
      const res = await axiosInstance.get(`admin/properties/city/list`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static agentStatusChange = async ({
    status,
    id,
  }: {
    status: string;
    id: string;
  }) => {
    try {
      const res = await axiosInstance.post(`admin/agents/${status}/${id}`);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static loginUser = async (data: any) => {
    try {
      const res = await axiosInstance.post(`admin/auth/login`, data);
      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static resendOtp = async (data: any, type: string) => {
    try {
      const res = await axiosInstance.post(
        `admin/auth/${type}/resend-email-verification`,
      );
      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static changePassword = async (data: any) => {
    try {
      const res = await axiosInstance.post(`admin/auth/change-password`, data);
      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static resetPassword = async (data: any) => {
    try {
      const res = await axiosInstance.post(`admin/auth/reset-password`, data);
      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static createAgencyProfile = async (data: any) => {
    try {
      const res = await axiosInstance.post(
        `agent/register/create-agency-profile`,
        data,
      );
      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static GetAgentProfile = async () => {
    try {
      const res = await axiosInstance.get(`agent/agent-details`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        window.location.href = clientRoutes.login;
        toast.error("Unauthorized, please login!");
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static updateAgentProfile = async (data: any, agent_id: string) => {
    try {
      const res = await axiosInstance.put(
        `client/agents/update/${agent_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updateAgent = async (data: any, agent_id: string) => {
    try {
      const res = await axiosInstance.post(
        `admin/agents/update/${agent_id}`,
        data,
      );
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };

  static updateInviteStatus = async () => {
    try {
      const res = await axiosInstance.post(
        `agent/agency-invitation/invitation-sent`,
      );

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgentById = async (params: { id: string }) => {
    try {
      const res = await axiosInstance.get(`admin/agents/${params.id}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static agentById = async (id: string) => {
    try {
      const res = await axiosInstance.get(`admin/agents/${id}`);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static getAgentList = async ({
    page,
    search,
    agency_ref,
    registration_status,
    status,
    start_date,
    end_date,
    city,
  }: {
    page: number;
    search: string;
    agency_ref: string;
    registration_status: string;
    status: string;
    start_date: string;
    end_date: string;
    city: string;
  }) => {
    try {
      const res = await axiosInstance.get(`admin/agents`, {
        params: {
          page,
          search,
          limit: 30,
          agency_ref,
          registration_status,
          status,
          start_date,
          end_date,
          city,
        },
      });

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      const status = err?.status;

      if (status === 401) {
        toast.error("Unauthorized, please login!");
        window.location.href = clientRoutes.login;
      }

      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static registerAgency = async (data: {
    role: string;
    email: string;
    invitation_code: string;
    principal_agent_id: string;
    principal_agent_first_name: string;
    principal_agent_last_name: string;
    principal_agent_mobile_number: string;
    phone_country_code: string;
  }) => {
    try {
      let url = "agent/register/register-agency";

      const res = await axiosInstance.post(url, data);

      return {
        data: res.data,
        success: true,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
        success: false,
      };
    }
  };

  static switchUserProfile = async (data: any) => {
    try {
      const res = await axiosInstance.post(`client/switch-user-profile`, data);
      return {
        data: res.data,
      };
    } catch (err: any) {
      return {
        error: "Something went wrong !",
        data: err?.response?.data,
      };
    }
  };
}
